import { styled } from "@linaria/react";
import dayjs, { Dayjs } from "dayjs";
import React, {  useEffect, useLayoutEffect, useRef, useState } from "react";
import chevronArrow from "@assets/icon/chevron-right-grey.svg";
import { themeDefault } from "src/theme-revamp";
import { toInteger } from "lodash";
import { SCREEN_SIZE } from "@static/screen-size";
interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  currentDate: string | dayjs.Dayjs;
  showCal: boolean,
  setShowCal: (argo: boolean)=>void,
  primaryColor?: string;
  secondaryColor?: string;
  format?: string;
  disableDateBefore?: string | dayjs.Dayjs;
  disabledDateAfter?: string | dayjs.Dayjs;
  onSelectDate: (e: string| dayjs.Dayjs) => void ;
}

enum IDMYView {
  month,
  year,
  date,
}

function Calendar({
  onSelectDate,
  disableDateBefore,
  disabledDateAfter,
  setShowCal,
  showCal,
  ...props
}: IProps) {
  const isValidDateProp = /^[0-9]{1,2}(-|\/)[0-9]{1,2}(-|\/)[0-9]{4}$/.test(typeof props.currentDate === "string"?props.currentDate:dayjs(props.currentDate).format("DD-MM-YYYY"))
  let selectedDate =
    typeof props.currentDate === "string"
      ? dayjs(props.currentDate)
      : (typeof props.currentDate?.isValid === "function"? props.currentDate :dayjs());
  if (!selectedDate.isValid()) {
    selectedDate = dayjs();
  }
  const selectedDateNumber = selectedDate.date();
  const [sheetView, setSheetView] = useState(IDMYView.date);
  const [displyedCalendarSheet, setDisplyedCalendarSheet] =
    useState(selectedDate);
  let containerCal = null
  const currentMonthStartDate = dayjs(displyedCalendarSheet.toDate()).set(
    "date",
    1
  );
  const dates: number[] = new Array(currentMonthStartDate.daysInMonth()||0).fill(
    1
  );
  const lastMonthdates: number[] = []; 
  const nextMonthdates: number[] = [];
  const isSameMonthAndYear =
    selectedDate.year() === currentMonthStartDate.year() &&
    selectedDate.month() === currentMonthStartDate.month();
  for (let d = currentMonthStartDate.day(); d > 0; d--) {
    lastMonthdates.push(currentMonthStartDate.subtract(d, "day").date());
  }
  for (
    let d = currentMonthStartDate
        .add(currentMonthStartDate.daysInMonth() - 1, "day")
        .day(),
      i = 1;
    d < 6;
    d++, i++
  ) {
    nextMonthdates.push(i);
  }

  const refEle = useRef<HTMLDivElement>(null)
  const container = useRef<any>(null)
  const trackStatus = useRef(false)
  const dateSelectedHandler =
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
      const dateSelected = e.target as unknown as HTMLDivElement;
      let date = displyedCalendarSheet
      if (!dateSelected.dataset.date) return;
      if (dateSelected.dataset.m === "prev") {
        date = date.subtract(1, 'month');
      } else if (dateSelected.dataset.m === "next") {
        date = date.add(1, "M");
      }
      if (typeof onSelectDate === "function") {
         date = date.set("date", +dateSelected.dataset.date!);
        onSelectDate(typeof props.currentDate === "object"?date: date.format("DD-MM-YYYY"));
        setDisplyedCalendarSheet(date);
      }
    }

  const changeCalendarSheet = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation()
    const btn = e.currentTarget as HTMLButtonElement;
    if (btn.dataset.btn === "prev")
      setDisplyedCalendarSheet((prev) => prev.subtract(1, "M"));
    else if (btn.dataset.btn === "next")
      setDisplyedCalendarSheet((prev) => prev.add(1, "M"));
  };

  const handleMonthChange = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation()
    const el = e.target as HTMLButtonElement;
    if (el.dataset.m) {
      setDisplyedCalendarSheet((prev) => prev.set("month", +el.dataset.m!));
    } else if (el.dataset.y) {
      setDisplyedCalendarSheet((prev) => prev.set("year", +el.textContent!));
    }
    setSheetView(IDMYView.date);
  };

  useLayoutEffect(()=>{
    setDisplyedCalendarSheet(selectedDate)
  },[props.currentDate])
  
  useEffect(()=>{
    const openClose = (e: any)=>{
      e.stopPropagation()
      e.preventDefault();
      container.current = document.querySelector("#cal-main")  

      if (showCal && container.current &&( !container.current.contains(e.target) )&& trackStatus.current){
        trackStatus.current=false
        setShowCal(false)
        
    }
    }
    document.addEventListener('click', openClose)
    const root = document.querySelector("#root")
    const datePicker = document.querySelector("#calendar")
    function resizeHandler(){
      if(window?.screen?.width < SCREEN_SIZE.mobilesUp){
        root?.appendChild(container.current!)   
        root?.classList.add("mobileBodyCalStyle") 
        if( container.current){
          container.current.style.position = ''}
          container.current?.classList.add("mobileCalStyle")
      }else{
        const calMain: any = document.querySelector("#cal-main")
        if( calMain){
          calMain.style.position = ''
          calMain.classList.remove("mobileCalStyle")
        }
        datePicker?.appendChild(calMain!)
      }
    }
    trackStatus.current = true

    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    return ()=>{
      document.removeEventListener("click", openClose);
      window.removeEventListener('resize', resizeHandler)

      const ele = document.querySelector("#cal-main");
      if (ele) {
        root?.removeChild(ele);
      }
      root?.classList.remove("mobileBodyCalStyle") 
    }
  },[])

  return (
    <div id="cal-main" ref={container} onClick={(e)=>{
      if(showCal && (e.target as any).id === "cal-main")
      {
       setShowCal(false)}}}>
    <CalendarContainer  ref={refEle} showCal={showCal} {...props}>
        <YearSheet
          show={sheetView === IDMYView.year }
          selectedYear={currentMonthStartDate.year()}
          onYearChange={handleMonthChange}
        />
        <MonthSheet
          show={sheetView === IDMYView.month}
          selectedMonth={currentMonthStartDate.month()}
          onMonthChange={handleMonthChange}
        />
      
       
        <DateSheet
          show={sheetView === IDMYView.date}
          lastMonthdates={lastMonthdates}
          dates={dates}
          nextMonthdates={nextMonthdates}
          selectedDateNumber={selectedDateNumber}
          isSameMonthAndYear={isSameMonthAndYear}
          dateSelectedHandler={dateSelectedHandler}
          changeCalendarSheet={changeCalendarSheet}
          displyedCalendarSheet={displyedCalendarSheet}
          setSheetView={setSheetView}
          isValidDateProp={isValidDateProp}
        />
    
    </CalendarContainer>
    </div>
  );
}

export default Calendar;

function YearSheet({
  onYearChange,
  selectedYear,
  show
}: {
  onYearChange: (e: any) => void;
  selectedYear: number;
  show: boolean
}) {
  const [yearStart, setYearStart] = useState(
    toInteger(selectedYear / 10) * 10 + 1
  );
  return (
    <>
      <div className={`date-container ${!show && 'hidden'}`}>
        <button
          data-btn="prev"
          onClick={() => setYearStart((prev) => prev - 10)}
        >
          <img src={chevronArrow} alt="prev" />
        </button>
        <div className="label">
          {yearStart}-{yearStart + 9}
        </div>
        <button
          data-btn="next"
          onClick={() => setYearStart((prev) => prev + 10)}
        >
          <img src={chevronArrow} alt="next" />
        </button>
      </div>
      <div className={`monthSheet ${!show && 'hidden'}`} onClick={onYearChange}>
        <button
          data-y="y"
          className={selectedYear === yearStart ? "selected" : ""}
        >
          {yearStart}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 1 ? "selected" : ""}
        >
          {yearStart + 1}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 2 ? "selected" : ""}
        >
          {yearStart + 2}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 3 ? "selected" : ""}
        >
          {yearStart + 3}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 4 ? "selected" : ""}
        >
          {yearStart + 4}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 5 ? "selected" : ""}
        >
          {yearStart + 5}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 6 ? "selected" : ""}
        >
          {yearStart + 6}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 7 ? "selected" : ""}
        >
          {yearStart + 7}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 8 ? "selected" : ""}
        >
          {yearStart + 8}
        </button>
        <button
          data-y="y"
          className={selectedYear === yearStart + 9 ? "selected" : ""}
        >
          {yearStart + 9}
        </button>
      </div>
    </>
  );
}

function MonthSheet({
  show,
  onMonthChange,
  selectedMonth,
}: {
  selectedMonth: number;
  show: boolean,
  onMonthChange: (e: any) => void;
}) {
  return (
    <>
      <div className={`label ${!show && "hidden"}`}>Month</div>
      <div className={`monthSheet ${!show && "hidden"}`} onClick={onMonthChange}>
        <button data-m="0" className={selectedMonth === 0 ? "selected" : ""}>
          Jan
        </button>
        <button data-m="1" className={selectedMonth === 1 ? "selected" : ""}>
          Feb
        </button>
        <button data-m="2" className={selectedMonth === 2 ? "selected" : ""}>
          Mar
        </button>
        <button data-m="3" className={selectedMonth === 3 ? "selected" : ""}>
          Apr
        </button>
        <button data-m="4" className={selectedMonth === 4 ? "selected" : ""}>
          May
        </button>
        <button data-m="5" className={selectedMonth === 5 ? "selected" : ""}>
          Jun
        </button>
        <button data-m="6" className={selectedMonth === 6 ? "selected" : ""}>
          Jul
        </button>
        <button data-m="7" className={selectedMonth === 7 ? "selected" : ""}>
          Aug
        </button>
        <button data-m="8" className={selectedMonth === 8 ? "selected" : ""}>
          Sep
        </button>
        <button data-m="9" className={selectedMonth === 9 ? "selected" : ""}>
          Oct
        </button>
        <button data-m="10" className={selectedMonth === 10 ? "selected" : ""}>
          Nov
        </button>
        <button data-m="11" className={selectedMonth === 11 ? "selected" : ""}>
          Dec
        </button>
      </div>
    </>
  );
}

function DateSheet({
  show,
  lastMonthdates,
  dates,
  nextMonthdates,
  selectedDateNumber,
  isSameMonthAndYear,
  dateSelectedHandler,
  changeCalendarSheet,
  setSheetView,
  displyedCalendarSheet,
  isValidDateProp
}: {
  lastMonthdates: number[];
  show: boolean,
  dates: number[];
  nextMonthdates: number[];
  selectedDateNumber: number;
  isSameMonthAndYear: boolean;
  isValidDateProp: boolean;
  dateSelectedHandler: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void;
  changeCalendarSheet: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  setSheetView: (e: any) => void;
  displyedCalendarSheet: dayjs.Dayjs;
}) {
  return (
    <>
      <div className={`date-container ${!show && 'hidden'}`}>
        <button data-btn="prev" onClick={changeCalendarSheet}>
          <img  src={chevronArrow} alt="prev" />
        </button>
        <div>
          <button onClick={() => setSheetView(IDMYView.month)}>
            {displyedCalendarSheet.format("MMM")}
          </button>
          <button onClick={() => setSheetView(IDMYView.year)}>
            {displyedCalendarSheet.format("YYYY")}
          </button>
        </div>
        <button data-btn="next" onClick={changeCalendarSheet}>
          <img src={chevronArrow} alt="next" />
        </button>
      </div>
      <div className={`dates-body ${!show && 'hidden'}`} onClick={dateSelectedHandler}>
        <div className="freezed-date black">S</div>
        <div className="freezed-date black">M</div>
        <div className="freezed-date black">T</div>
        <div className="freezed-date black">W</div>
        <div className="freezed-date black">T</div>
        <div className="freezed-date black">F</div>
        <div className="freezed-date black">S</div>
        {lastMonthdates.map((date, i) => (
          <button key={`prev-${date}`} data-m="prev" data-date={date} className="freezed-date">
            {date}
          </button>
        ))}
        {dates.map((date, i) => (
          <button
            key={`current-${i}`}
            data-m="current"
            // autoFocus={selectedDateNumber === i + 1 && isSameMonthAndYear}
            data-date={i + 1} 
            className={`${
              (selectedDateNumber === i + 1 && isSameMonthAndYear && isValidDateProp)
                ? "selected"
                : ""
            }`}
          >
            {i + 1}
          </button>
        ))}
        {nextMonthdates.map((date) => (
          <button key={`next-${date}`} data-m="next" data-date={date} className="freezed-date">
            {date}
          </button>
        ))}
      </div>
    </>
  );
}

const CalendarContainer = styled.div<{
  showCal:boolean;
  primaryColor?: string;
  secondaryColor?: string;
}>`
 
  border-radius: 16px;
  position: relative;
  z-index: 10;
  background-color: white;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px 0px #0000000D;
  width: 100%;
  display: ${(prop)=>prop.showCal?"flex":"none"};
  height: 100%;
  padding: 24px;
  max-width: 296px;
  max-height: 388px;
  color: #434343;
  gap: 24px;
  flex-direction: column;
  user-select: none;
  .label {
    color: #434343;
    font-size: 14px;
    font-weight: 600;
  }
  .monthSheet {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    button {
      background-color: #f5f5f5;
      padding: 14px 22px;
      border-radius: 10px;
      border: 1px transparent solid;
      &:hover:not(.selected) {
        border: ${(prop) => ` 1px ${prop.primaryColor || "#883E89"} solid`};
        color: ${(props) => props.primaryColor || "#883E89"};
      }
    }
  }
  
  & > .date-container {
    display: flex;
    align-items: center;
    justify-items: center;
    justify-content: space-between;
    button {
      width: 24px;
      height: 24px;
      background: none;
      border: none;
      cursor: pointer;
    }
    & > button:first-child,
    & > button:last-child {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    & > button:first-child {
      transform: rotateZ(180deg);
    }
    div {
      display: flex;
      gap: 12px;
      button {
        background: #f5f5f5;
        width: 68px;
        height: 44px;
        border: none;
        border-radius: 100px;
      }
    }
  }
  .dates-body {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    justify-items: center;
    .freezed-date {
      color: #c9c9c9;
      cursor: auto;
    }
    .black {
      color: #434343;
    }
    button {
      width: 32px;
      height: 32px;
      font-weight: 600;
      line-height: 19.6px;
      background-color: transparent;
      text-align: center;
      display: flex;
      justify-content: center;
      padding-top:3px;
      color: #434343;
      align-items: center;
      cursor: pointer;
      border-radius: 100%;
      border: 1px transparent solid;
      transition: all 0.2s linear;
      &:hover:not(.selected) {
        border: ${(prop) => ` 1px ${prop.primaryColor || "#883E89"} solid`};
        color: ${(props) => props.primaryColor || "#883E89"};
      }
    }
  }
  .selected,
  button.selected {
    background-color: ${(props) => props.primaryColor || "#883E89"};
    color: white;
  }
  .hidden {
    display: none;
  }
`;
